// import the original component so that base styles are applied first
import 'SourceComponent/Menu/Menu.component';
// import our modified styles to override some of the default ones
import './Menu.override.style.scss';

// re-export all the original exports from the parent theme untouched
export * from 'SourceComponent/Menu/Menu.component';
export { default } from 'SourceComponent/Menu/Menu.component';